<template lang="pug">
  div(class="infuture-wrapper")
    section-title(title="これからのSMOUT")

    div(class="infuture-block")
      div(class="description")
        | 2020年、地域との関わり方はより多様になる。
        br
        | 地域に関わりたいすべての人が、
        br(class="smOnly")
        | 地域と出会えるサービスを目指します。
      div(class="note")
        | 地域に移住したい人、関わりたい人は増えています。
        br
        | そして、関わる機会と方法を模索している人もたくさんいます。
        br
        | 私たちはインターネット技術とアイデアで、地域と人との距離と関係を近づけ、地域と暮らし、暮らしをつくる人を増やします。
        br
        | SMOUTと一緒に地域へ行こう。暮らしをつくろう。
      div(class="smout")
        a(class="button", href="/")
          | SMOUTサイトへ
</template>
<script>
  import SectionTitle from 'modules/components/Event/Infographics/SectionTitle.vue';

  export default {
    components: {
      SectionTitle,
    },
  };
</script>
<style lang="scss" scoped>
  @import 'stylesheets/pages/event/infographics/_variables.scss';

  .smOnly {
    @include mq('sm') {
      display: none;
    }
  }

  .infuture-wrapper {
    padding-bottom: 40px;
  }

  .infuture-block {
    text-align: center;
    overflow: hidden;
    padding-top: 70px;
    padding-bottom: 90px;
    background-image: url('~images/Event/Infographics/in_future_background.svg?file');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 320px;
    @include mq('sm') {
      padding-top: 130px;
      padding-bottom: 150px;
      background-size: 440px;
    }
    @include mq('md') {
      padding-top: 150px;
      padding-bottom: 170px;
      background-size: 480px;
    }
  }
  .description {
    text-align: center;
    font-size: 1.6rem;
    font-weight: 400;
    line-height: 1.8;
    @include mq('sm') {
      font-size: 1.8rem;
    }
    @include mq {
      font-size: 2rem;
    }
    @include mq('xs') {
      font-size: 1.4rem;
    }
  }
  .note {
    font-size: 1.2rem;
    font-weight: 300;
    max-width: 350px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 1.5em;
    @include mq('sm') {
      font-size: 1.4rem;
      max-width: 410px;
    }
    @include mq {
      font-size: 1.6rem;
      max-width: 464px;
    }
    @include mq('xs') {
      font-size: 1rem;
    }
  }
  .smout {
    text-align: center;
    margin-top: 60px;
    margin-bottom: -60px;
    @include mq {
      margin-top: 100px;
      margin-bottom: -100px;
    }
  }
  .button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 1.6rem;
    color: #fff;
    line-height: 1.2;
    text-align: center;
    min-height: 40px;
    background-color: $c-pink;
    border: 1px solid $c-pink;
    border-radius: 5px;
    cursor: pointer;
    user-select: none;
    appearance: none;
    padding: 1em 2em;
    @include mq {
      font-size: 1.8rem;
      transition: color 0.3s, background-color 0.3s;
      &:hover {
        color: $c-pink;
        background-color: #fff;
      }
    }
  }
</style>
